<template>
  <v-card class="pa-4" outlined elevation="8">
    <v-card-text>
      <v-data-table-server
        :headers="headers"
        :items="commissionsItems"
        :items-length="totalItems"
        items-per-page="-1"
        :loading="loadingDatatables"
        :search="search"
        hide-default-footer
        class="text-caption"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <v-icon
                color="medium-emphasis"
                :icon="mdiFormatListBulleted"
                size="x-small"
                start
              ></v-icon>

              Répartition des commissions
            </v-toolbar-title>

            <v-chip class="mx-3" color="primary" variant="outlined">
              Année contractuelle : {{ displayedContractYear }}
            </v-chip>

            <v-select
              v-model="selectedYear"
              :items="availableYears"
              label="Année"
              variant="outlined"
              hide-details
              density="compact"
              style="max-width: 150px"
              class="mr-3"
              clearable
              @update:model-value="onYearChange"
            ></v-select>

            <v-text-field
              v-model="search"
              label="Rechercher"
              :prepend-inner-icon="mdiMagnify"
              variant="outlined"
              hide-details
              single-line
              class="pr-5"
            ></v-text-field>

            <v-btn
              :icon="mdiFileDownloadOutline"
              rounded="lg"
              border
              @click="exportExcelCommissions"
            ></v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.moreThan10kCatalog="{ item }">
          <v-btn
            class="ma-2"
            :color="item.moreThan10kCatalog ? 'green' : 'red'"
            :icon="item.moreThan10kCatalog ? mdiCheckBold : mdiClose"
            variant="text"
          ></v-btn>
        </template>

        <template v-slot:item.moreThan10kOutCatalog="{ item }">
          <v-btn
            class="ma-2"
            :color="item.moreThan10kOutCatalog ? 'green' : 'red'"
            :icon="item.moreThan10kOutCatalog ? mdiCheckBold : mdiClose"
            variant="text"
          ></v-btn>
        </template>
      </v-data-table-server>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiFormatListBulleted,
  mdiMagnify,
  mdiCheckBold,
  mdiClose,
  mdiFileDownloadOutline,
} from "@mdi/js";
import { mapState } from "vuex";
import contractYear from "@/mixins/contractYear";

export default {
  name: "CommissionsKpi",
  components: {},
  mixins: [contractYear],
  data() {
    return {
      mdiFormatListBulleted,
      mdiMagnify,
      mdiCheckBold,
      mdiClose,
      mdiFileDownloadOutline,
      search: "",
      selectedYear: null,
      availableYears: [],
    };
  },
  mounted() {
    this.initializeYears();
  },
  computed: {
    ...mapState({
      commissionsItems: (state) => state.kpi.commissions,
      loadingDatatables: (state) => state.loadingTables,
    }),
    headers() {
      return [
        {
          title: "Code Client",
          key: "customerNumber",
        },
        {
          title: "Nom Client",
          key: "customerName",
        },
        {
          title: "Franchise Group",
          key: "franchiseGroup",
        },
        {
          title: "Franchise",
          key: "sapgCustom",
        },
        {
          title: "Montant Prix Catalogue",
          key: "totalCatalogPrice",
        },
        {
          title: "Dépassement 10K ?",
          key: "moreThan10kCatalog",
        },
        {
          title: "Commissions 1.8%",
          key: "commissionCatalog",
        },
        {
          title: "Montant Prix Hors Catalogue",
          key: "totalOutCatalogPrice",
        },
        {
          title: "Dépassement 10K ?",
          key: "moreThan10kOutCatalog",
        },
        {
          title: "Commissions 3%",
          key: "commissionOutCatalog",
        },
        {
          title: "Total des commandes",
          key: "totalPrice",
        },
        {
          title: "Total des commissions",
          key: "totalCommission",
        },
      ];
    },
    totalItems() {
      return this.commissionsItems.length;
    },
    /**
     * Année contractuelle affichée (celle sélectionnée ou l'actuelle)
     */
    displayedContractYear() {
      return this.selectedYear || this.currentYear;
    },
  },
  methods: {
    /**
     * Initialise la liste des années disponibles
     * À partir de 2025 jusqu'à l'année contractuelle actuelle
     */
    initializeYears() {
      const currentYear = this.currentYear;
      const startYear = 2025;
      const years = [];
      for (let i = startYear; i <= currentYear; i++) {
        years.push(i);
      }
      this.availableYears = years;
    },
    /**
     * Appelée lorsque l'utilisateur change l'année sélectionnée
     */
    onYearChange() {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("kpi/fetchKPICommissions", this.selectedYear)
        .then(() => {
          this.$store.commit("setOverlay", false);
        })
        .catch(() => {
          this.$store.commit("setOverlay", false);
          this.$store.dispatch("showSnackbar", {
            message: "Erreur lors du chargement des données.",
            color: "error",
          });
        });
    },
    exportExcelCommissions() {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("kpi/exportExcelCommissions", this.selectedYear)
        .then((response) => {
          this.$store.commit("setOverlay", false);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // Create a link element
          const link = document.createElement("a");
          // Set the download attribute with the desired file name
          link.download = "Commissions.xlsx";

          // Create a URL for the Blob and set it as the link's href
          link.href = window.URL.createObjectURL(blob);

          // Append the link to the document
          document.body.appendChild(link);

          // Trigger a click on the link to start the download
          link.click();

          // Remove the link from the document
          document.body.removeChild(link);
        })
        .catch((error) => {
          if (error.status == 400) {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: "Action non autorisée.",
              color: "error",
            });
          } else {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.export-excel"),
              color: "error",
            });
          }
        });
    },
  },
};
</script>
